import { FC } from 'react'

import Router from 'src/Router/index'
import { useSentry } from 'src/Hooks/useSentry'

import { useRedirect } from './useRediect'
import { useCaptureScVid } from './useCaptureScVid'
import { useGoogleSignupEvent } from './useGoogleSignupEvent'
import { useGoogleSignupSurveyRedirect } from './useGoogleSignupSurveyRedirect'
import { useSpotifyCuratorSignupEvent } from './useSpotifyCuratorSignupEvent'
import { useSpotifyReconnectResult } from '../../Hooks/useSpotifyReconnectResult'
import { useInitApiCalls } from './useInitApiCalls'
import { useAnalyticsCookies } from './useAnalyticsCookies'
import { useSetupIntercom } from './useSetupIntercom'
import { useAppLoader } from './useAppLoader'
import { useApplyPendingReferralBonuses } from './useApplyPendingReferralBonuses'
import { useApplyPendingCampaignCreation } from './useApplyPendingCampaignCreation'

const App: FC = () => {
  useSetupIntercom()
  useSentry()
  useCaptureScVid()
  useRedirect()
  useGoogleSignupEvent()
  useGoogleSignupSurveyRedirect()
  useSpotifyCuratorSignupEvent()
  useSpotifyReconnectResult()
  useApplyPendingReferralBonuses()
  useApplyPendingCampaignCreation()
  useInitApiCalls()
  useAnalyticsCookies()
  useAppLoader()

  return (
    <div>
      <Router />
    </div>
  )
}

export default App
